import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

const AlertBox = ({children, type = 'warning', onDismiss, showIcon = true}) => {
  const mainClasses = classNames('fds-c-alert-box', 'fds-u-mt2', {
    '-type-success': type === 'success',
    '-type-alert': type === 'failure'
  })
  const iconClasses = classNames('e-icon', {
    '-icon-flag': type === 'warning',
    '-icon-ok': type === 'success',
    '-icon-alert': type === 'failure'
  })

  const onDismissWrapper = (event) => {
    event.preventDefault()
    onDismiss(event)
  }

  return (
    <div className={mainClasses}>
      {showIcon ? <div className='fds-c-alert-box__icon'>
        <i className={iconClasses} />
      </div> : null}
      <div className='fds-c-alert-box__message'>
        <p className='fds-c-text-body -size-s fds-u-m0'>{children}</p>
      </div>
      {onDismiss ? <AlertBox.DismissButton onClick={onDismissWrapper} /> : null}
    </div>
  )
}

AlertBox.propTypes = {
  type: PropTypes.oneOf(['warning', 'success', 'failure']),
  onDismiss: PropTypes.func
}

AlertBox.DismissButton = ({onClick}) => {
  return (
    <div className='fds-c-alert-box__dismiss'>
      <a onClick={onClick} className='fds-c-alert-box__dismiss-icon'>
        <i className='e-icon -icon-cancel' />
      </a>
    </div>
  )
}

AlertBox.DismissButton.propTypes = {
  onClick: PropTypes.func
}

export default AlertBox



// WEBPACK FOOTER //
// ./client/components/alerts/alertBox.js